/** @format — Helpers to detect AG-UI (component) chat messages */

import { filterKnownUiComponents } from "./normalizeComponents";

export function hasKnownAguiComponents(uiComponents) {
  return filterKnownUiComponents(uiComponents).length > 0;
}

export function isAguiChatMessage(message) {
  if (!message || message.role !== "agent") return false;
  if (message.isAgui === true) return true;
  return hasKnownAguiComponents(message.uiComponents);
}
